// extracted by mini-css-extract-plugin
export default {"wrapper":"_319f29","subHeader":"_9be1dcc1","swiperList":"_c6727f2"};